export type Gender = "male" | "female" | "other";

export type User = {
  id: string;
  name: string;
  email: string;
  gender: Gender;
  age: number;
  avatarUrl: string | null;
  region: number | null;
};

/**
 * API の gender(0=男性/1=女性/2=その他。BE `Common.User` 定数と一致)を Gender へ変換する。
 */
export const toGender = (value: number): Gender => {
  switch (value) {
    case 0:
      return "male";
    case 1:
      return "female";
    default:
      return "other";
  }
};
